export default () => ({
	faqs: [],
	faqItem:{},
	error: null,
});
